import { render, staticRenderFns } from "./DocBuilderDemo.vue?vue&type=template&id=d92a54f4&scoped=true&"
import script from "./DocBuilderDemo.vue?vue&type=script&lang=js&"
export * from "./DocBuilderDemo.vue?vue&type=script&lang=js&"
import style0 from "./DocBuilderDemo.vue?vue&type=style&index=0&id=d92a54f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92a54f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d92a54f4')) {
      api.createRecord('d92a54f4', component.options)
    } else {
      api.reload('d92a54f4', component.options)
    }
    module.hot.accept("./DocBuilderDemo.vue?vue&type=template&id=d92a54f4&scoped=true&", function () {
      api.rerender('d92a54f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/docBuilder/vistas/DocBuilderDemo.vue"
export default component.exports